<template>
  <div class="ranking-area">
    <p>今日の良い行い TOP5</p>
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="10" md="10" lg="10" v-for="n in 3" :key="n" class="ranking-text">
        <PointRankingLargeText
          :ranking-num="rankingNums[n - 1]"
          :ranking-text="topActionsName[n - 1]"
          :ranking-item-num="topActionsNum[n - 1]"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="10" md="10" lg="10" v-for="n in 2" :key="n" class="ranking-text">
        <PointRankingSmallText
          :ranking-num="rankingNums[n + 2]"
          :ranking-text="topActionsName[n + 2]"
          :ranking-item-num="topActionsNum[n + 2]"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PointRankingLargeText from '../Molecules/PointRankingLargeText'
import PointRankingSmallText from '../Molecules/PointRankingSmallText'

export default {
  name: "PointRanking",
  data: () => ({
  }),
  created() {
  },
  mounted() {
  },
  computed: {
    topActionsName() {
      let topActions = []
      if (!this.doneEcosRanking || !this.doneEcosRanking.length) {
        return ["", "", "", "", ""]
      }
      for (let rankingItem of this.doneEcosRanking) {
        topActions.push(rankingItem.name)
      }
      return topActions
    },
    topActionsNum() {
      let topActionsNum = []
      if (!this.doneEcosRanking || !this.doneEcosRanking.length) {
        return ["", "", "", "", ""]
      }
      for (let rankingItem of this.doneEcosRanking) {
        topActionsNum.push(rankingItem.count)
      }
      return topActionsNum
    },
    rankingNums() {
      let rankingNums = []
      if (!this.doneEcosRanking || !this.doneEcosRanking.length) {
        return ["", "", "", "", ""]
      }
      let rankingNum = 1
      let maxNum = 0
      if (this.doneEcosRanking.length <= 5) {
        maxNum = this.doneEcosRanking.length
      } else {
        maxNum = 5
      }
      for (let i = 0; i < maxNum ; i ++) {
        if (i === 0) {
          rankingNums.push(rankingNum)
        } else {
          if (this.doneEcosRanking[i - 1].count === this.doneEcosRanking[i].count) {
            rankingNums.push(rankingNum)
          } else {
            rankingNum = rankingNum + 1
            rankingNums.push(rankingNum)
          }
        }
      }
      return rankingNums
    }
  },
  methods: {
  },
  components: {
    PointRankingLargeText,
    PointRankingSmallText
  },
  props: ["doneEcosRanking"]
};

</script>

<style scoped>
p {
  color: #fff;
  font-weight: bold;
  font-size: 1em;
}
.vertical-no-padding-col {
  padding: 0 12px;
}
.ranking-area {
  border: 1px dashed #ffffff;
  border-radius: 30px;
  padding: 20px;
}
.ranking-text {
  padding: 0 12px;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
